import * as React from "react";
import Svg, { Circle, Path } from "react-native-svg";
const StatusIcon = (props: any) => (
  <Svg
    width={16}
    height={16}
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <Circle cx={8} cy={8} r={8} transform="rotate(-180 8 8)" fill="#F9BD20" />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.09451 6.6656C8.25575 6.66325 8.41699 6.6572 8.57814 6.65942C8.84886 6.66321 8.99295 6.80441 8.99752 7.07486C9.00221 7.35054 8.99881 7.62633 8.99881 7.90209C8.99881 9.09359 8.99897 10.2851 8.99873 11.4766C8.99869 11.8638 8.87366 11.9893 8.48495 11.9924C8.36535 11.9934 8.24575 11.9913 8.12619 11.9907C7.90367 11.8001 7.90211 11.5453 7.90316 11.2801C7.90844 9.99441 7.9073 8.70866 7.9041 7.42295C7.90348 7.15208 7.8832 6.88105 8.09451 6.6656Z"
      fill="white"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.09524 6.66579C7.88393 6.88124 7.90416 7.15227 7.90486 7.42306C7.90807 8.70877 7.90916 9.99452 7.90393 11.2802C7.90287 11.5454 7.90443 11.8002 8.12695 11.9908C7.97095 11.9937 7.81456 12.0048 7.65906 11.9976C7.39331 11.9854 7.25109 11.8323 7.25055 11.5658C7.2491 10.8107 7.25 10.0557 7.25 9.30059C7.24996 8.57156 7.24953 7.84256 7.25019 7.11352C7.25051 6.79214 7.38444 6.65852 7.70508 6.65895C7.83514 6.65919 7.96517 6.66344 8.09524 6.66579Z"
      fill="white"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.28074 3.77951C8.70277 3.86614 8.99282 4.20841 8.99607 4.62373C8.99939 5.05412 8.70476 5.39718 8.24984 5.49268C8.20145 5.45604 8.15626 5.41382 8.10407 5.38374C7.74586 5.17723 7.58767 4.782 7.69805 4.38484C7.78414 4.07549 8.00975 3.90731 8.28074 3.77951Z"
      fill="white"
    />
    <Path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.28125 3.77977C8.01026 3.90753 7.78465 4.07576 7.69861 4.38511C7.58823 4.78226 7.74641 5.1775 8.10463 5.384C8.15677 5.41412 8.202 5.45634 8.25039 5.49294C7.76423 5.57446 7.3343 5.22871 7.25575 4.76039C7.1806 4.31254 7.4814 3.8791 7.94542 3.77544C8.05174 3.75177 8.16903 3.77708 8.28125 3.77977Z"
      fill="white"
    />
  </Svg>
);
export default StatusIcon;
